<sc-dialog-title>
  <sc-dictionary-label dictionaryKey="tmc-yard.ui.clean-transport.title"></sc-dictionary-label>
</sc-dialog-title>
<sc-padding>
  <form [formGroup]="optionsFormGroup">
    <mat-radio-group formControlName="cleanupAction">
      <div>
        <mat-radio-button [disabled]="!archiveTransportEnabled" value="archiveTransport">
          <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.clean-transport.option.archive-transport"></sc-dictionary-label>
        </mat-radio-button>
      </div>
      <div>
        <mat-radio-button [disabled]="!assignVehicleToStationEnabled" value="assignVehicleToStation">
          <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.clean-transport.option.assign-vehicle-to-station"></sc-dictionary-label>
        </mat-radio-button>
        @if (assignVehicleToStationVisible) {
          <sc-content-spacer vertical></sc-content-spacer>
          <mat-form-field appearance="fill" class="station-field">
            <mat-label>
              <sc-dictionary-label
              dictionaryKey="tmc-yard.ui.clean-transport.option.assign-vehicle-to-station.target-station"></sc-dictionary-label>
            </mat-label>
            <input matInput formControlName="vehicleTargetStationName" name="vehicleTargetStationName" [required]="true"
              [readonly]="true">
              <sc-action-icon matSuffix (click)="assignVehicleTargetStation()"
              iconClass="fa-sitemap"></sc-action-icon>
            </mat-form-field>
          }
        </div>
      </mat-radio-group>
    </form>
  </sc-padding>
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()" dictionaryKey="tmc-yard.common.action.cancel"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary [disabled]="!confirmEnabled" (click)="confirm()"
      dictionaryKey="tmc-yard.action.dialog.confirm"></sc-confirm-button>
    </sc-flex>
  </sc-padding>
